<template>
  <div class="scenario-container muzik-game">
    <!-- <div class="header">
      <div class="logo" />MUZIK
    </div> -->
    <div class="show-score">
      分數： {{ playScore }}
    </div>
    <div v-if="(nodeListPostion <= nodeListLength)"
         class="game-controls"
    >
      <div v-if="!playStatus" class="setting">
        速度：
        <a :class="{'active': gameSpeed === 120}"
           href="#" @click="gameSpeed = 120"
        >
          低
        </a>
        <a :class="{'active': gameSpeed === 100}"
           href="#" @click="gameSpeed = 100"
        >
          中
        </a>
        <a :class="{'active': gameSpeed === 60}"
           href="#" @click="gameSpeed = 60"
        >
          高
        </a>
      </div>
      <a v-else
         herf="#" class="btn-game-start paused" @click="gameStop"
      />
    </div>
    <div class="note">
      <div v-if="!playStatus" class="game-mask">
        <a herf="#" class="btn btn-game-start" @click="gameStart" />
      </div>
      <div v-else-if="playStatus && nodeListPostion >= nodeListLength" class="game-over">
        <a href="#" class="btn" @click="gameRestart">
          再玩一次
        </a>
        <a v-if="locale !== 'zh-CN'" href="#" class="btn share" @click="shareToFacebook">
          分享到Facebook
        </a>
      </div>
      <ul v-else :style="{'top': nodeListPostion + 'px'}">
        <li v-for="(note, index) in playNoteArray"
            :key="'note'+index"
            :class="[note[0], 'len'+note[2],
                     {'out': (nodeListPostion > note[3]+(note[2]*1.2)),
                      'now': (nodeListPostion > note[3]) && (nodeListPostion < note[3]+(note[2]*1.2)),
                      'clicked': note[4]}]"
            :style="{'height': note[2]*1.2+'px',
                     'bottom': note[3]+'px',
                     'animation-duration': (note[2] * tempo / 1000)+'s'}"
        />
      </ul>
    </div>
    <div class="keyboard-container">
      <!--Keyboard-->
      <div :class="{'helpOn': helpOn}" class="keyboard">
        <div v-for="(empty, index) in emptyCount" :key="'key'+index"
             class="key white oct"
        />
        <div data-note="c4" data-key="81" class="key white oct" @click="onClickPlay">
          q
          <div data-note="db4" data-key="50" class="key black black1 oct" @click="onClickPlay">
            2
          </div>
        </div>
        <div data-note="d4" data-key="87" class="key white oct" @click="onClickPlay">
          w
          <div data-note="eb4" data-key="51" class="key black black2 oct" @click="onClickPlay">
            3
          </div>
        </div>
        <div data-note="e4" data-key="69" class="key white" @click="onClickPlay">
          e
        </div>
        <div data-note="f4" data-key="82" class="key white" @click="onClickPlay">
          r
          <div data-note="gb4" data-key="53" class="key black black3" @click="onClickPlay">
            5
          </div>
        </div>
        <div data-note="g4" data-key="84" class="key white" @click="onClickPlay">
          t
          <div data-note="ab4" data-key="54" class="key black black4" @click="onClickPlay">
            6
          </div>
        </div>
        <div data-note="a4" data-key="89" class="key white" @click="onClickPlay">
          y
          <div data-note="bb4" data-key="55" class="key black black5" @click="onClickPlay">
            7
          </div>
        </div>
        <div data-note="b4" data-key="85" class="key white" @click="onClickPlay">
          u
        </div>
        <div data-note="c5" data-key="88" class="key white" @click="onClickPlay">
          x
          <div data-note="db5" data-key="68" class="key black black6" @click="onClickPlay">
            d
          </div>
        </div>
        <div data-note="d5" data-key="67" class="key white" @click="onClickPlay">
          c
          <div data-note="eb5" data-key="70" class="key black black7" @click="onClickPlay">
            f
          </div>
        </div>
        <div data-note="e5" data-key="86" class="key white" @click="onClickPlay">
          v
        </div>
        <div data-note="f5" data-key="66" class="key white" @click="onClickPlay">
          b
          <div data-note="gb5" data-key="72" class="key black black8" @click="onClickPlay">
            h
          </div>
        </div>
        <div data-note="g5" data-key="78" class="key white" @click="onClickPlay">
          n
          <div data-note="ab5" data-key="74" class="key black black9" @click="onClickPlay">
            j
          </div>
        </div>
        <div data-note="a5" data-key="77" class="key white" @click="onClickPlay">
          m
          <div data-note="bb5" data-key="75" class="key black black10" @click="onClickPlay">
            k
          </div>
        </div>
        <div data-note="b5" data-key="188" class="key white" @click="onClickPlay">
          ,
        </div>
        <div data-note="c6" data-key="190" class="key white" @click="onClickPlay">
          .
        </div>
        <div v-for="(empty, index) in emptyCount" :key="index"
             class="key white oct"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Game',
  components: {},
  data() {
    return {
      emptyCount: 0,
      interval: '',
      volume: 0.5,
      tempo: 0,
      helpOn: true,
      gameSpeed: 100,
      nodeListLength: 0,
      nodeListPostion: 0,
      playScore: 0,
      playStatus: false,
      playNoteArray: [],
      frequencies: [
        ['rest', 0],
        ['b3', 233.08],
        ['c4', 261.63],
        ['db4', 277.18],
        ['d4', 293.66],
        ['eb4', 311.13],
        ['e4', 329.63],
        ['f4', 349.23],
        ['gb4', 369.99],
        ['g4', 392.0],
        ['ab4', 415.3],
        ['a4', 440.0],
        ['bb4', 466.16],
        ['b4', 493.88],
        ['c5', 523.25],
        ['db5', 554.37],
        ['d5', 587.33],
        ['eb5', 622.25],
        ['e5', 659.25],
        ['f5', 698.46],
        ['gb5', 739.99],
        ['g5', 783.99],
        ['ab5', 830.61],
        ['a5', 880.0],
        ['bb5', 932.33],
        ['b5', 987.77],
        ['c6', 1046.5],
        ['d6', 1174.66],
        ['e6', 1318.51]
      ],
      noSuprises: [
        ['rest', 0],
        ['a5', 50],
        ['c5', 50],
        ['f5', 50],
        ['c5', 50],
        ['a5', 50],
        ['c5', 50],
        ['f5', 50],
        ['c5', 50],
        ['a5', 50],
        ['c5', 50],
        ['f5', 50],
        ['c5', 50],
        ['bb4', 50],
        ['db5', 50],
        ['f5', 50],
        ['g5', 50],
        ['a5', 50],
        ['c5', 50],
        ['f5', 50],
        ['c5', 50],
        ['a5', 50],
        ['c5', 50],
        ['f5', 50],
        ['c5', 50],
        ['a5', 50],
        ['c5', 50],
        ['f5', 50],
        ['c5', 50],
        ['bb4', 50],
        ['db5', 50],
        ['f5', 50],
        ['g5', 50],
        ['a4', 200],
        ['c4', 200],
        ['a4', 50],
        ['a4', 100],
        ['g4', 200],
        ['a4', 50],
        ['a4', 200],
        ['b3', 150],
        ['rest', 25],
        ['b3', 25],
        ['a4', 50],
        ['a4', 100],
        ['g4', 100],
        ['f4', 100],
        ['bb4', 200],
        ['d4', 200],
        ['e4', 50],
        ['e4', 100],
        ['f4', 100],
        ['g4', 100],
        ['a4', 250]
      ],
      lifeOnMars: [
        ['rest', 0],
        ['ab4', 50],
        ['bb4', 50],
        ['c5', 50],
        ['db5', 50],
        ['c5', 50],
        ['bb4', 100],
        ['ab4', 50],
        ['c5', 100],
        ['rest', 200],
        ['ab4', 50],
        ['bb4', 50],
        ['c5', 50],
        ['db5', 50],
        ['c5', 50],
        ['bb4', 100],
        ['ab4', 50],
        ['f5', 100],
        ['rest', 200],
        ['db5', 50],
        ['eb5', 50],
        ['f5', 50],
        ['gb5', 50],
        ['f5', 50],
        ['eb5', 100],
        ['db5', 50],
        ['f5', 150],
        ['rest', 150],
        ['db5', 50],
        ['eb5', 50],
        ['f5', 50],
        ['gb5', 50],
        ['f5', 50],
        ['eb5', 100],
        ['db5', 50],
        ['db5', 100],
        ['bb5', 200],
        ['f5', 200],
        ['eb5', 50],
        ['eb5', 50],
        ['eb5', 50],
        ['d5', 50],
        ['bb4', 100],
        ['c5', 100],
        ['rest', 50],
        ['bb5', 100],
        ['f5', 200],
        ['eb5', 50],
        ['eb5', 50],
        ['d5', 100],
        ['c5', 100],
        ['d5', 100],
        ['c5', 200],
        ['rest', 150],
        ['c5', 50],
        ['c5', 50],
        ['c5', 50],
        ['d5', 50],
        ['c5', 50],
        ['f5', 100],
        ['eb5', 25],
        ['d5', 25],
        ['c5', 100],
        ['rest', 150],
        ['bb4', 50],
        ['bb4', 50],
        ['bb4', 50],
        ['c5', 50],
        ['bb4', 100],
        ['bb5', 200],
        ['f5', 200],
        ['eb5', 50],
        ['eb5', 50],
        ['eb5', 50],
        ['d5', 50],
        ['bb4', 100],
        ['c5', 100],
        ['rest', 50],
        ['bb5', 100],
        ['f5', 200],
        ['eb5', 50],
        ['eb5', 50],
        ['eb5', 50],
        ['d5', 50],
        ['c5', 50],
        ['d5', 50],
        ['c5', 100],
        ['rest', 300],
        ['c5', 50],
        ['c5', 50],
        ['c5', 50],
        ['c5', 50],
        ['d5', 50],
        ['c5', 50],
        ['f5', 100],
        ['eb5', 25],
        ['d5', 25],
        ['c5', 100],
        ['rest', 200],
        ['bb4', 50],
        ['bb4', 50],
        ['bb4', 50],
        ['c5', 50],
        ['bb4', 100],
        ['bb5', 600]
      ],
      furElise: [
        ['rest', 0],
        ['e5', 25],
        ['eb5', 25],
        ['e5', 25],
        ['eb5', 25],
        ['e5', 25],
        ['b4', 25],
        ['d5', 25],
        ['c5', 25],
        ['a4', 50],
        ['rest', 25],
        ['c4', 25],
        ['e4', 25],
        ['a4', 25],
        ['b4', 50],
        ['rest', 25],
        ['e4', 25],
        ['ab4', 25],
        ['b4', 25],
        ['c5', 50],
        ['rest', 25],
        ['e4', 25],
        ['e5', 25],
        ['eb5', 25],
        ['e5', 25],
        ['eb5', 25],
        ['e5', 25],
        ['b4', 25],
        ['d5', 25],
        ['c5', 25],
        ['a4', 50],
        ['rest', 25],
        ['c4', 25],
        ['e4', 25],
        ['a4', 25],
        ['b4', 50],
        ['rest', 25],
        ['e4', 25],
        ['c5', 25],
        ['b4', 25],
        ['a4', 50],
        ['rest', 25],
        ['b4', 25],
        ['c5', 25],
        ['d5', 25],
        ['e5', 75],
        ['g4', 25],
        ['f5', 25],
        ['e5', 25],
        ['d5', 75],
        ['f4', 25],
        ['e5', 25],
        ['d5', 25],
        ['c5', 75],
        ['e4', 25],
        ['d5', 25],
        ['c5', 25],
        ['b4', 50],
        ['rest', 25],
        ['e4', 25],
        ['e5', 25],
        ['rest', 25],
        ['e5', 25],
        ['e6', 25],
        ['rest', 25],
        ['eb5', 25],
        ['e5', 50],
        ['rest', 25],
        ['eb5', 25],
        ['e5', 25],
        ['eb5', 25],
        ['e5', 25],
        ['eb5', 25],
        ['e5', 25],
        ['b4', 25],
        ['d5', 25],
        ['c5', 25],
        ['a4', 100]
      ],
      theEntertainer: [
        ['rest', 0],
        ['d6', 50],
        ['e6', 50],
        ['c6', 50],
        ['a5', 100],
        ['b5', 50],
        ['g5', 100],
        ['d5', 50],
        ['e5', 50],
        ['c5', 50],
        ['a4', 100],
        ['b4', 50],
        ['g4', 100],
        ['d5', 50],
        ['e5', 50],
        ['c5', 50],
        ['a4', 100],
        ['b4', 50],
        ['a4', 50],
        ['ab4', 50],
        ['g4', 100],
        ['rest', 50],
        ['g5', 100],
        ['d4', 50],
        ['d4', 50],
        ['e4', 50],
        ['c5', 100],
        ['e4', 50],
        ['c5', 100],
        ['e4', 50],
        ['c5', 300],
        ['c5', 50],
        ['d5', 50],
        ['eb5', 50],
        ['e5', 50],
        ['c5', 50],
        ['d5', 50],
        ['e5', 100],
        ['b4', 50],
        ['d5', 100],
        ['c5', 300],
        ['d4', 50],
        ['d4', 50],
        ['e4', 50],
        ['c5', 100],
        ['e4', 50],
        ['c5', 100],
        ['e4', 50],
        ['c5', 300],
        ['a4', 50],
        ['g4', 50],
        ['gb4', 50],
        ['a4', 50],
        ['c5', 50],
        ['e5', 100],
        ['d5', 50],
        ['c5', 50],
        ['a4', 50],
        ['d5', 300],
        ['d4', 50],
        ['d4', 50],
        ['e4', 50],
        ['c5', 100],
        ['e4', 50],
        ['c5', 100],
        ['e4', 50],
        ['c5', 300],
        ['c5', 50],
        ['d5', 50],
        ['eb5', 50],
        ['e5', 50],
        ['c5', 50],
        ['d5', 50],
        ['e5', 100],
        ['b4', 50],
        ['d5', 100],
        ['c5', 300],
        ['c5', 50],
        ['d5', 50],
        ['e5', 50],
        ['c5', 50],
        ['d5', 50],
        ['e5', 100],
        ['c5', 50],
        ['d5', 50],
        ['c5', 50],
        ['e5', 50],
        ['c5', 50],
        ['d5', 50],
        ['e5', 100],
        ['c5', 50],
        ['d5', 50],
        ['c5', 50],
        ['e5', 50],
        ['c5', 50],
        ['d5', 50],
        ['e5', 100],
        ['b4', 50],
        ['d5', 100],
        ['c5', 250]
      ],
      shareLinkdefault: window.location.href
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ]
    }
  },
  computed: {
    title() {
      const productionLocaleName = this.$t(`${this.$production.toUpperCase()}.TITLE`)
      return `${this.$t('GAME.TITLE')} | ${productionLocaleName} | MUZIK AIR`
    },
    cover() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const coverPath = this.$production.toLowerCase()
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
    },
    keywords() {
      return this.$t('GAME.TITLE')
    },
    canonicalURL() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`
    },
    locale() {
      return this.$i18n.locale
    }
  },
  mounted() {
    const windowWidth = document.body.clientWidth
    this.emptyCount = Math.ceil((windowWidth - 600) / 45 / 2)
    window.addEventListener('keydown', this.keyDownSearch)
    this.setFbAsyncInit()
    this.initFbLoadSDK()
  },
  methods: {
    gameStart() {
      if (this.nodeListPostion === 0) {
        const song = this.lifeOnMars
        let length = 300
        song.forEach((note, index) => {
          this.frequencies.forEach(frequency => {
            if (note[0] === frequency[0]) {
              length = (index > 0) ? Number(length) + Number(song[index - 1][1] * 1.2) + 8 : Number(length)
              this.playNoteArray.push([note[0], frequency[1], note[1], length, false])
            }
          })
        })
        this.nodeListLength = length + Number(song[song.length - 1][1] * 1.2)
      }
      this.playStatus = true
      this.gameTimerStart()
    },
    gameTimerStart() {
      this.interval = setInterval(() => {
        this.gameTimer()
      }, this.gameSpeed)
    },
    gameStop() {
      this.playStatus = false
      clearInterval(this.interval)
    },
    gameRestart() {
      this.playStatus = false
      this.playScore = 0
      this.nodeListPostion = 0
      this.playNoteArray = []
      clearInterval(this.interval)
    },
    gameTimer() {
      this.nodeListPostion = this.nodeListPostion + 5
      if (this.nodeListPostion >= this.nodeListLength) {
        clearInterval(this.interval)
      }
    },
    // Create new audio context when note played
    playAudioNote(note, length, noteClass) {
      const AudioContext = window.AudioContext || window.webkitAudioContext
      const ctx = new AudioContext()
      const oscillator = ctx.createOscillator()
      const gainNode = ctx.createGain()
      oscillator.type = 'triangle'
      oscillator.frequency.value = note
      gainNode.gain.value = this.volume
      oscillator.connect(gainNode)
      gainNode.connect(ctx.destination)
      oscillator.start(0)
      // Check if click the right key
      let lastNote = null
      lastNote = this.playNoteArray.find(note => {
        return (this.nodeListPostion > note[3]) && (this.nodeListPostion < note[3] + (note[2] * 1.2))
      })
      if (lastNote && (lastNote[0] === noteClass) && !lastNote[4]) {
        lastNote[4] = true
        length = lastNote[2] * 2
        this.playScore += 10
      } else {
        this.playScore -= 3
      }
      // Trying to prevent popping sound on note end. Probably can be improved
      gainNode.gain.setTargetAtTime(0, length / 1000 - 0.05, 0.08)
      oscillator.stop(ctx.currentTime + (length / 1000 + 0.2))
      oscillator.onended = () => ctx.close()
    },
    // Finds clicked element returns data-note value and runs playKey function
    onClickPlay(e) {
      let key = 0
      let length = 300
      let noteClass = e.target.dataset.note
      for (let i = 0; i < this.frequencies.length; i++) {
        if (this.frequencies[i][0] === noteClass) {
          key = this.frequencies[i][1]
        }
      }
      this.addVisual(e.target)
      this.playAudioNote(key, length, noteClass)
    },
    // Finds pressed key and returns data-note value
    keyDownSearch(event) {
      let key = 0
      let length = 300
      let keyPressed = document.querySelector(`div[data-key="${event.keyCode}"]`)
      if (keyPressed === null) {
        return
      }
      let note = keyPressed.dataset.note
      for (let i = 0; i < this.frequencies.length; i++) {
        if (this.frequencies[i][0] === note) {
          key = this.frequencies[i][1]
        }
      }
      this.addVisual(keyPressed)
      this.playAudioNote(key, length, note)
    },
    // add each note to setinterval and playAudioNote
    playDemoSong(arr, e) {
      let noteLength = 0
      e.target.classList.add('on')
      this.playStatus = true
      this.playScore = 0
      this.playNoteArray = []
      // this.playNoteArray = arr
      for (let i = 1; i < arr.length; i++) {
        noteLength += arr[i - 1][2] * this.tempo
        setTimeout(() => {
          this.playAudioNote(arr[i][1], arr[i][2] * this.tempo)
          this.playNoteArray.push(arr[i])
          if (arr[i][1] !== 0) {
            // document.querySelector(`[data-note=${arr[i][0]}]`).classList.add('played')
          }
          setTimeout(() => {
            if (arr[i][1] !== 0) {
              // document.querySelector(`[data-note=${arr[i][0]}]`).classList.remove('played')
            }
            if (arr.length - 2 < i) {
              e.target.classList.remove('on')
              this.playStatus = false
            }
          }, arr[i][2] * this.tempo - 0.05)
        }, noteLength)
      }
    },
    // map notes in song to frequencies
    findFrequencies(song, e) {
      let arr = []
      song.forEach(note => {
        this.frequencies.forEach(frequency => {
          if (note[0] === frequency[0]) {
            arr.push([note[0], frequency[1], note[1]])
          }
        })
      })
      this.playDemoSong(arr, e)
    },
    // adds css class when note played
    addVisual(key, length) {
      key.classList.add('played')
      setTimeout(() => {
        key.classList.remove('played')
      }, length || 300)
    },
    // Facebook share
    setFbAsyncInit() {
      /* eslint-disable */
      window.fbAsyncInit = () => {
        FB.init({
          appId            : process.env.VUE_APP_FB_APP_ID,
          autoLogAppEvents : true,
          xfbml            : true,
          version          : process.env.VUE_APP_FB_SDK_VER
        });
        // code here
      }
      /* eslint-enable */
    },
    initFbLoadSDK() {
      /* eslint-disable */
      const localeStr = this.$i18n.locale.replace('-', '_'); // need semi before IIFE
      (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        // js.src = 'https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v3.0&appId=340910659677580&autoLogAppEvents=1';
        js.src = `https://connect.facebook.net/${localeStr}/sdk.js`;
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
      /* eslint-enable */
    },
    shareToFacebook() {
      if (window.FB) {
        window.FB.ui({
          method: 'share',
          href: this.shareLinkdefault,
          hashtag: '#MuzikGame',
          quote: '我拿了' + this.playScore + '分！快來玩玩看'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.muzik-game{
  position: relative;
  .show-score{
    display: block;
    position: absolute;
    top: 1.4em;
    left: 1.4em;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .game-controls{
    display: block;
    position: absolute;
    top: 2em;
    right: 2em;
    .demo-buttons{
      .demo-button{
        display: inline-block;
        // float: left;
        .btn{
          border-radius: 5%;
          border: none;
          padding: 10px 20px;
          margin: 0 2px 5px;
          cursor: pointer;
          outline: none;
          &.demo{
            background: $theme-red-hover;
            &.on {
              background: $theme-red;
            }
          }
          &.help {
            background: $theme-yellow-hover;
            &.on {
              background: $theme-yellow;
            }
          }
        }
        p{
          color: #fff;
          text-align: center;
          margin: 0;
          padding: 0;
        }
      }
      &:after{
        content: "";
        display: block;
        clear: both;
      }
    }
    .setting{
      text-align: center;
      color: #e5e5e5;
      font-size: 18px;
      a {
        display: inline;
        color: #808080;
        text-decoration: none;
        margin-right: 1em;
        &.active{
          color: #fff;
          font-weight: 600;
        }
      }
      .input{
        display: inline-block;
        padding-left: 10px;
        width: 100px;
      }
      p{
        margin: 0;
        padding: 10px 0 0;
        color: #fff;
      }
    }
    .btn-game-start{
      position: relative;
      height: 30px;
      border-width: 15px 0 15px 18px;
      &.paused {
        border-width: 0px 0 0px 18px;
      }
    }
  }
}

.keyboard-container {
  display: block;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  overflow: hidden;
  margin: 0 auto;
  background: #111;
  box-shadow: 10px 2px 10px #090909, 2px 10px 10px #090909;
  // font-family: 'Condiment', cursive;
  text-align: center;
  font-size: 18px;
  @media (max-width: 700px) {
    font-size: 14px;
  }
  @media (max-width: 500px) {
    font-size: 10px;
  }
}

.controls-container {
  display: flex;
  width: 100%;
  justify-content: space-around;
  &.playing {
    button.demo-button,
    input {
      pointer-events: none;
      cursor: default;
    }
  }
}

//Keyboard
.keyboard {
  width: 100%;
  height: 35vh;
  display: flex;
  position: relative;
  &.helpOn {
    .white {
      color: #000;
    }
    .black {
      color: #fff;
    }
  }
}

%key-style {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 2rem;
  border-radius: 5px;
  // border: 1px solid black;
  font-family: sans-serif;
  font-size: 16px;
  padding-bottom: 5px;
  outline: none;
}

.white {
  @extend %key-style;
  height: 100%;
  width: 45px;
  min-width: 45px;
  background-color: ivory;
  color: ivory;
  box-shadow: 2px 7px 2px #222222;
  background: #fff;
  background: linear-gradient(-30deg,#f5f5f5,#fff);
  border: 1px solid #ccc;
  box-shadow: inset 0 1px 0px #fff, inset 0 -1px 0px #fff, inset 1px 0px 0px #fff, inset -1px 0px 0px #fff, 0 4px 3px rgba(0,0,0,0.7);
  border-radius: 0 0 3px 3px;
  &.played {
    // color: #dddddd;
    // transform: translate(0, 2px);
    background: linear-gradient(-30deg, #dcdcdc, #dcdcdc);
    color: ivory;
    box-shadow: 0 2px 2px rgba(0,0,0,0.4);
    position: relative;
    border-top: 2px solid #aaa;
    &:before{
      content: "";
      width: 0px;
      height: 0px;
      border-width: 35vh 4px 0px;
      border-style: solid;
      border-color: transparent transparent transparent rgba(0,0,0,0.1);
      position: absolute;
      left: 0px;
      top: 0px;
    }
    &:after{
      content: "";
      width: 0px;
      height: 0px;
      border-width: 35vh 4px 0px;
      border-style: solid;
      border-color: transparent rgba(0,0,0,0.1) transparent transparent;
      position: absolute;
      right: 0px;
      top: 0px;
    }
    > .black{
      top: -2px;
    }
  }
}

.black {
  @extend %key-style;
  height: 70%;
  width: 26px;
  position: absolute;
  z-index: 2;
  margin-left: -1.6%;
  background-color: #000;
  color: #000;
  background: #333;
  background: linear-gradient(-20deg,#333,#000,#333);
  z-index: 10;
  border-width: 1px 2px 7px;
  border-style: solid;
  border-color: #666 #222 #111 #555;
  box-shadow: inset 0px -1px 2px rgba(255,255,255,0.4), 0 2px 3px rgba(0,0,0,0.4);
  border-radius: 0 0 2px 2px;

  @media (max-width: 600px) {
    // width: 6%;
  }
  &.played {
    border-bottom-width: 2px;
    height: 70.2%;
    box-shadow: inset 0px -1px 1px rgba(255,255,255,0.4), 0 1px 0px rgba(0,0,0,0.8), 0 2px 2px rgba(0,0,0,0.4), 0 -1px 0px #000;
  }
}

.key{
  position: relative;
  >.black{
    position: absolute;
    top: -1px;
    right: -28%;
  }
}

.oct {
  @media (max-width: 600px) {
    display: none;
  }
}

// note
.note{
  ul{
    position: relative;
    top: 0;
    max-width: 675px;
    min-height: 65vh;
    margin: auto;
    padding: 0;
    // overflow: hidden;
    transition: .4s;
    li{
      display: inline-block;
      position: absolute;
      width: 20px;
      background: #e23a3b;
      opacity: 1;
      transition: .2s;
      &.out{
        opacity: 0;
      }
      &.clicked{
        opacity: .5;
      }
      &.rest{
        display: none;
      }
      // white
      &.b3{
        left: -33px;
      }
      &.c4{
        left: 12.5px;
      }
      &.d4{
        left: 57.5px;
      }
      &.e4{
        left: 102.5px;
      }
      &.f4{
        left: 147.5px;
      }
      &.g4{
        left: 192.5px;
      }
      &.a4{
        left: 237.5px;
      }
      &.b4{
        left: 282.5px;
      }
      &.c5{
        left: 327.5px;
      }
      &.d5{
        left: 372.5px;
      }
      &.e5{
        left: 417.5px;
      }
      &.f5{
        left: 462.5px;
      }
      &.g5{
        left: 507.5px;
      }
      &.a5{
        left: 552.5px;
      }
      &.b5{
        left: 597.5px;
      }
      &.c6{
        left: 642.5px;
      }
      // black
      &.db4{
        left: 32px;
      }
      &.eb4{
        left: 77px;
      }
      &.gb4{
        left: 167px;
      }
      &.ab4{
        left: 212px;
      }
      &.bb4{
        left: 257px;
      }
      &.db5{
        left: 347px;
      }
      &.eb5{
        left: 392px;
      }
      &.gb5{
        left: 482px;
      }
      &.ab5{
        left: 527px;
      }
      &.bb5{
        left: 572px;
      }
      &.len25{
        background: #e23a3b;
      }
      &.len50{
        background: #e23a3b;
      }
      &.len100{
        background: #e23a3b;
      }
      &.len150{
        background: #a10903;
      }
      &.len200{
        background: #a10903;
      }
      &.len250{
        background: #a10903;
      }
      &.len300{
        background: #850e09;
      }
      &.len600{
        background: #850e09;
      }
    }
  }
  .game-mask,
  .game-over{
    position: relative;
    max-width: 675px;
    width: 100%;
    height: 65vh;
    margin: auto;
  }
  .game-over{
    padding-top: 25vh;
    .btn{
      width: 50%;
      display: block;
      background: #808080;
      line-height: 60px;
      font-size: 20px;
      text-align: center;
      margin: 0 auto;
      margin-bottom: 15px;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
      text-decoration: none;
      &.share{
        background: #4367b2;
      }
    }
  }
}

.btn-game-start{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border: 0;
  background: transparent;
  box-sizing: border-box;
  width: 0;
  height: 90px;
  border-color: transparent transparent transparent #f5f5f5;
  transition: 100ms all ease;
  cursor: pointer;
  // play state
  border-style: solid;
  border-width: 45px 0 45px 68px;
  &:hover {
    border-color: transparent transparent transparent #d5d5d5;
  }
  &.paused {
    border-style: double;
    border-width: 0px 0 0px 60px;
  }
}
</style>
